<template>
    <div class="min-h-screen flex items-center justify-center bg-gray-100">
        <div class="p-6 max-w-sm w-full bg-white shadow-lg rounded-lg">
            <h2 class="text-2xl font-bold mb-6 text-center">Reset password</h2>

            <div class="flex flex-col gap-4">
                <label class="ui-input ui-input-bordered flex items-center gap-2">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                        fill="currentColor"
                        class="h-4 w-4 opacity-70"
                    >
                        <path d="M2.5 3A1.5 1.5 0 0 0 1 4.5v.793c.026.009.051.02.076.032L7.674 8.51c.206.1.446.1.652 0l6.598-3.185A.755.755 0 0 1 15 5.293V4.5A1.5 1.5 0 0 0 13.5 3h-11Z" />
                        <path d="M15 6.954 8.978 9.86a2.25 2.25 0 0 1-1.956 0L1 6.954V11.5A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5V6.954Z" />
                    </svg>
                    <input
                        v-model="email"
                        type="text"
                        class="grow"
                        placeholder="Email"
                    />
                </label>

                <div
                    v-if="invalidFeedback"
                    role="alert"
                    class="ui-alert ui-alert-error"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6 shrink-0 stroke-current"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                    <span>{{ invalidFeedback }}</span>
                </div>

                <div
                    v-if="successFeedback"
                    role="alert"
                    class="ui-alert ui-alert-success"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6 shrink-0 stroke-current"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                    <span>{{ successFeedback }}</span>
                </div>

                <button
                    v-if="!successFeedback"
                    class="ui-btn bg-primary mt-4"
                    @click="resetPassword"
                >
                    Send reset email
                </button>

                <a class="ui-link ui-link-neutral mx-auto">
                    <router-link to="/login">Back to login</router-link>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from 'system/firebase.js';

export default {
    name: 'ForgotPassword',
    data() {
        return {
            email: '',
            invalidFeedback: '',
            successFeedback: '',
        };
    },
    methods: {
        resetPassword() {
            this.invalidFeedback = '';
            this.successFeedback = '';

            if (!this.email.includes('@')) {
                this.invalidFeedback = 'Oops, the provided email is not valid';
                return;
            }

            sendPasswordResetEmail(auth, this.email)
                .then(() => {
                    this.successFeedback = 'Check your inbox for a reset link';
                })
                .catch((error) => {
                    if (error.code === 'auth/user-not-found') {
                        this.invalidFeedback = 'Oops, no account found with that email';
                    } else if (error.code === 'auth/invalid-email') {
                        this.invalidFeedback = 'Oops, the provided email is not valid';
                    } else {
                        this.invalidFeedback = 'Oooops, error sending reset email';
                        console.log(error);
                    }
                });
        },
    },
};
</script>
